// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[],\"staticRoutes\":[],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "15.5.28";import * as Sentry from '@sentry/nextjs';
import { env } from 'lib/constants/env';

Sentry.init({
  // Gives more context
  attachStacktrace: true,
  debug: false,
  // Things that we simply don't about
  dsn: env.NEXT_PUBLIC_SENTRY_DSN,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // If the entire session is not sampled, use the below sample rate to sample
  // sessions when an error occurs.
  replaysOnErrorSampleRate: 1.0,
  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: 0.1,
  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  ignoreErrors: ['The operation is insecure', 'Failed to probe Service Worker'],
  tracesSampleRate: 0.2,
  // Add optional integrations for additional features
});
